var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// import { Link } from 'react-router-dom';
import * as React from 'react';
import { LocalizedText } from 'bernie-l10n';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkCardLink } from 'uitk-react-cards';
import { useStores } from '../../../../utils/hooks/useStores';
export var CardLink = function (_a) {
  var activity = _a.activity,
    onClick = _a.onClick,
    index = _a.index;
  var _b = useStores(),
    activityDetailStore = _b.activityDetailStore,
    detailCriteriaStore = _b.detailCriteriaStore;
  var resetInfositeForNewActivity = function (newActivity) {
    if (detailCriteriaStore.getActivityId() !== newActivity.id) {
      activityDetailStore.resetDetailsPage(newActivity);
    }
  };
  var handleClick = function (isMobile) {
    if (onClick) {
      if (isMobile) {
        resetInfositeForNewActivity(activity);
      }
      onClick(activity, index);
    }
  };
  var primary = activity.primary;
  var isCardLinkView = function (isMobile) {
    var _a, _b;
    var targetProp = isMobile ? null : {
      target: '_blank'
    };
    return React.createElement(UitkCardLink, null, React.createElement("a", __assign({
      "data-testid": "card-link",
      onClick: function () {
        return handleClick(isMobile);
      },
      href: ((_b = (_a = activity.clickAction) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b.relativePath) || ''
    }, targetProp), primary.text, React.createElement("span", {
      className: "is-visually-hidden"
    }, React.createElement(LocalizedText, {
      message: "lx.search.card.infosite.link.accessibility.text"
    }))));
  };
  return React.createElement(Viewport, null, React.createElement(ViewSmall, null, isCardLinkView(true)), React.createElement(ViewLarge, null, isCardLinkView(false)));
};